import { useTranslation as useTranslationI18 } from 'react-i18next'
import { useCallback } from 'react'

// eslint-disable-next-line import/prefer-default-export
export const useTranslation = () => {
    const { t } = useTranslationI18()

    /* Fix changes in handling missing key for processDefinition namespace */
    const safeT = useCallback((key, options?) => {
        const translation = t(key, options)

        return (translation as string).replace('processDefinition:', '')
    }, [t])

    return { t: safeT }
}
